import React, { useEffect, useRef, useState } from "react";
import { saveAs } from "file-saver";
import "./imageAnnotator.css";
import "./header.css"
import { toast } from 'react-toastify';
import ENVURL from "./env";
import eraserr from "./eraser.png"

// const getFileUrlFromQuery = () => {
//   const params = new URLSearchParams(window.location.search);
//   return params.get("fileurl");
// };

// const gettools = () => {
//     const params = new URLSearchParams(window.location.search);
  
//     const getBool = (key, defaultVal = true) => {
//       const val = params.get(key);
//       return val === null ? defaultVal : val === "true";
//     };
  
//     return {
//       pencil: getBool("showPencil"),
//       text: getBool("showText"),
//       highlight: getBool("showHighlight"),
//       freeDrawing: getBool("showFreeDrawing"),
//       symbol:getBool("showSymbol"),
//       color: getBool("showColor"),
//       size: getBool("showSize"),
//       undo: getBool("showUndo"),
//       redo: getBool("showRedo"),
//       save: getBool("showSave"),
//       download: getBool("showDownload"),
//     };
//   };
// const ImageAnnotator = () => {
  const ImageAnnotator = ({
    fileUrl,
    studentId,
    fileId,
    instId,
    authToken,
    attachId,
    fileName,
    tools,
  }) => {
    const [image, setImage] = useState(null);
    const [viewOriginal, setViewOriginal] = useState(false);
    const [draggingTextBoxId, setDraggingTextBoxId] = useState(null);

    const [showOriginal, setShowOriginal] = useState(false);
    const backupState = useRef(null);
    const [eraserBox, setEraserBox] = useState({
      x: 100,
      y: 100,
      width: 40,
      height: 40,
      size: 80,
      isDragging: false,
    });
    
  const [file, setFile] = useState(null);
  const [tool, setTool] = useState(null);
  const [color, setColor] = useState("#FF0000");
  const [fontSize, setFontSize] = useState(16);
  const canvasRef = useRef(null);
  const drawnLines = useRef([]);
  const [textBoxes, setTextBoxes] = useState([]);
  const [selectedBoxId, setSelectedBoxId] = useState(null);
  const [undoStack, setUndoStack] = useState([]);
const [redoStack, setRedoStack] = useState([]);
const [activePage, setActivePage] = useState(0);
// const [tools, settools] = useState(gettools());
const [isDropdownVisible, setDropdownVisible] = useState(false); 
const [selectedEmoji, setSelectedEmoji] = useState('😀');
const [emojiAnnotations, setEmojiAnnotations] = useState([]); // each item: { id, pageIndex, x, y, emoji }
const drawnEmojis = useRef([]);
const drawnSymbols = useRef([]);
const [selectedSymbol, setSelectedSymbol] = useState('✓');
const [showConfirmation, setShowConfirmation] = useState(false);
const eraserRef = useRef(null);

// const [fileName,setFileName]=useState(null)

  // useEffect(() => {
  //   const url = getFileUrlFromQuery();
  //   if (url) setFile(url);
  //   const name = url.split("/").pop();
  //     setFileName(name);
  // }, []);

  // useEffect(() => {
  //   if (file) {
  //     const img = new Image();
  //     img.crossOrigin = "anonymous"; // ✅ THIS FIXES THE TAINTED CANVAS

  //     img.src = file;
  //     img.onload = () => setImage(img);
  //   }
  // }, [file]);
  // useEffect(() => {
  //   if (fileUrl) {
  //     const img = new Image();
  //     img.crossOrigin = "anonymous";
  //     img.src = fileUrl;

  //     img.onload = () => {
  //       setImage(img);
  //     };
  //     img.onerror = (e) => {
  //       console.error("Image failed to load:", e);
  //     };
  //   }
  // }, [fileUrl]);
 


useEffect(() => {
  drawCanvas();
}, [tool, eraserBox]);

useEffect(() => {
  if (fileUrl) {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = fileUrl;

    img.onload = () => {
      const canvas = canvasRef.current;
      if (!canvas) return;

      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      // ✅ Always scale to "contain"
      const scale = Math.min(
        viewportWidth / img.width,
        viewportHeight / img.height
      );

      const targetWidth = img.width * scale;
      const targetHeight = img.height * scale;

      // ✅ Add blank space so it's centered
      const offsetX = (viewportWidth - targetWidth) / 2;
      const offsetY = (viewportHeight - targetHeight) / 2;

      // Canvas fills screen
      canvas.width = viewportWidth;
      canvas.height = viewportHeight;

      setImage({
        el: img,
        width: targetWidth,
        height: targetHeight,
        offsetX,
        offsetY,
        scaleX: scale,
        scaleY: scale,
      });
    };
  }
}, [fileUrl]);





  useEffect(() => {
    const handleClickOutside = (e) => {
        if (!e.target.classList.contains('text-box')) {
            if (tool === 'text') {
              setTool(null); // Deactivate text tool
            }
            setSelectedBoxId(null); // Reset selected text box if clicked outside
          }
      
    };
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, [tool]);
  useEffect(() => {
    if (!image || !canvasRef.current) return;
    drawCanvas(); // Don't reset canvas size here!
  }, [image, textBoxes]);
  

   
  const drawEmoji = (ctx, emoji, x, y) => {
    ctx.font = "24px Arial";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(emoji, x, y);
  };
  const drawSymbol = (ctx, symbol, x, y, fontSize, color) => {
    // Set the font size and color for the symbol
    ctx.font = `${fontSize}px Arial`;
    ctx.fillStyle = color;
  
    // Ensure we don't draw a stray dot by positioning the symbol carefully
    // Adjust the `x` and `y` position so that the symbol is centered properly
    const adjustedX = x - fontSize / 2; // Adjust X to center symbol if necessary
    const adjustedY = y + fontSize / 2; // Adjust Y to properly place the symbol
  
    // Draw the symbol
    ctx.fillText(symbol, adjustedX, adjustedY);
  };
  

  const drawLine = (ctx, line) => {
    ctx.strokeStyle = line.tool === "highlight" ? line.color + "70" : line.color;
    ctx.lineWidth = line.tool === "highlight" ? 20 : 2;
    ctx.lineCap = "round";
    ctx.beginPath();
    ctx.moveTo(line.start.x, line.start.y);
    ctx.lineTo(line.end.x, line.end.y);
    ctx.stroke();
  };

  const handleToolClick = (toolName) => {
    setTool(toolName); // Set the tool based on button clicked
  };
  
  const drawCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    if (!canvas || !ctx || !image?.el) return;
  
    // Clear canvas and fill with white background
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  
    // Draw the image scaled and centered
    ctx.drawImage(
      image.el,
      image.offsetX,
      image.offsetY,
      image.width,
      image.height
    );
  
    if (viewOriginal) return;
  
    // 🔶 Draw lines
    drawnLines.current.forEach((line) => {
      const startX = image.offsetX + line.start.x * image.scaleX;
      const startY = image.offsetY + line.start.y * image.scaleY;
      const endX = image.offsetX + line.end.x * image.scaleX;
      const endY = image.offsetY + line.end.y * image.scaleY;
  
      ctx.strokeStyle = line.tool === "highlight" ? line.color + "70" : line.color;
      ctx.lineWidth = line.tool === "highlight" ? 20 : 2;
      ctx.lineCap = "round";
      ctx.beginPath();
      ctx.moveTo(startX, startY);
      ctx.lineTo(endX, endY);
      ctx.stroke();
    });
  
    // 🔶 Draw symbols
    drawnSymbols.current.forEach((symbol) => {
      const x = image.offsetX + symbol.x * image.scaleX;
      const y = image.offsetY + symbol.y * image.scaleY;
  
      drawSymbol(ctx, symbol.symbol, x, y, symbol.fontSize, symbol.color);
  
      if (tool === "symbol" && selectedSymbol === symbol) {
        ctx.strokeStyle = "blue";
        ctx.lineWidth = 1;
        ctx.strokeRect(x - 5, y - symbol.fontSize, symbol.fontSize + 10, symbol.fontSize + 10);
  
        const handleX = x + symbol.fontSize + 2;
        const handleY = y + 2;
        ctx.fillStyle = "white";
        ctx.strokeStyle = "black";
        ctx.lineWidth = 1;
        ctx.fillRect(handleX, handleY, 10, 10);
        ctx.strokeRect(handleX, handleY, 10, 10);
      }
    });
  
    // 🔶 Draw emojis
    drawnEmojis.current.forEach((emoji) => {
      const x = image.offsetX + emoji.x * image.scaleX;
      const y = image.offsetY + emoji.y * image.scaleY;
  
      ctx.font = `${emoji.fontSize || 24}px Arial`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(emoji.emoji, x, y);
    });
  
    // 🔶 Draw eraser icon (if active)
    if (tool === "eraser" && !showOriginal) {
      const img = new Image();
      img.src = "/eraser.png";
      img.onload = () => {
        const size = eraserBox.size * ((image?.scaleX + image?.scaleY) / 2); // scale icon
        ctx.drawImage(
          img,
          image.offsetX + eraserBox.x * image.scaleX,
          image.offsetY + eraserBox.y * image.scaleY,
          size,
          size
        );
      };
    }
    
  };
  
  const handleReset = () => {
    const snapshot = {
      drawnLines: [...drawnLines.current],
      drawnSymbols: [...drawnSymbols.current],
      drawnEmojis: [...drawnEmojis.current],
      textBoxes: [...textBoxes],
    };
  
    // Push the current state as a reset action
    addActionToHistory({
      type: "reset",
      data: snapshot,
    });
  
    // Clear everything
    drawnLines.current = [];
    drawnSymbols.current = [];
    drawnEmojis.current = [];
    setTextBoxes([]);
    setSelectedBoxId(null);
    setTool(null);
  
    drawCanvas();
  };
  
  const liveErase = (x, y, size) => {
    const pageIndex = 0; // For images, everything is on a single "page"
  
    // Convert eraser box (canvas space) to image-space rect
    const rect = {
      left: (x - image.offsetX) / image.scaleX,
      top: (y - image.offsetY) / image.scaleY,
      right: (x + size - image.offsetX) / image.scaleX,
      bottom: (y + size - image.offsetY) / image.scaleY,
    };
  
    // ✅ Erase Lines
    const removedLines = [];
    drawnLines.current = drawnLines.current.filter((line) => {
      const intersects =
        (line.start.x >= rect.left && line.start.x <= rect.right &&
         line.start.y >= rect.top && line.start.y <= rect.bottom) ||
        (line.end.x >= rect.left && line.end.x <= rect.right &&
         line.end.y >= rect.top && line.end.y <= rect.bottom);
      if (intersects) removedLines.push(line);
      return !intersects;
    });
  
    // ✅ Erase Symbols
    const removedSymbols = [];
    drawnSymbols.current = drawnSymbols.current.filter((sym) => {
      const inside =
        sym.x >= rect.left && sym.x <= rect.right &&
        sym.y >= rect.top && sym.y <= rect.bottom;
      if (inside) removedSymbols.push(sym);
      return !inside;
    });
  
    // ✅ Erase Emojis
    const removedEmojis = [];
    drawnEmojis.current = drawnEmojis.current.filter((emo) => {
      const inside =
        emo.x >= rect.left && emo.x <= rect.right &&
        emo.y >= rect.top && emo.y <= rect.bottom;
      if (inside) removedEmojis.push(emo);
      return !inside;
    });
  
    // ✅ Erase Text Boxes
    let removedTextBoxes = [];
    setTextBoxes((prev) => {
      const remaining = [];
      const removed = [];
  
      for (const box of prev) {
        const boxLeft = (box.left - image.offsetX) / image.scaleX;
        const boxTop = (box.top - image.offsetY) / image.scaleY;
        const boxRight = boxLeft + box.width / image.scaleX;
        const boxBottom = boxTop + box.height / image.scaleY;
  
        const overlaps =
          boxLeft < rect.right &&
          boxRight > rect.left &&
          boxTop < rect.bottom &&
          boxBottom > rect.top;
  
        if (overlaps) {
          removed.push(box);
        } else {
          remaining.push(box);
        }
      }
  
      removedTextBoxes = removed;
      return remaining;
    });
  
    // ✅ Add everything to undo history
    if (
      removedLines.length ||
      removedSymbols.length ||
      removedEmojis.length ||
      removedTextBoxes.length
    ) {
      addActionToHistory({
        type: "erase",
        lines: removedLines,
        symbols: removedSymbols,
        emojis: removedEmojis,
        boxes: removedTextBoxes,
      });
    }
  
    drawCanvas();
  };
  
  
  // useEffect(() => {
  //   const handleResize = () => {
  //     const canvas = canvasRef.current;
  //     if (!canvas || !image?.el) return;
  
  //     const parent = canvas.parentElement;
  //     const canvasWidth = parent.clientWidth;
  
  //     // Maintain image aspect ratio
  //     const scale = canvasWidth / image.el.width;
  //     const canvasHeight = image.el.height * scale;
  
  //     canvas.width = canvasWidth;
  //     canvas.height = canvasHeight;
  
  //     // Update image state
  //     setImage((prev) => ({
  //       ...prev,
  //       width: canvasWidth,
  //       height: canvasHeight,
  //       offsetX: 0,
  //       offsetY: 0,
  //       scaleX: scale,
  //       scaleY: scale,
  //     }));
  
  //     drawCanvas();
  //   };
  
  //   window.addEventListener("resize", handleResize);
  //   handleResize(); // call immediately to set initial size
  
  //   return () => window.removeEventListener("resize", handleResize);
  // }, [image?.el]);
  
  
  // 🎯 Attach mouse + touch start events
useEffect(() => {
  const canvas = canvasRef.current;
  if (!canvas) return;

  const downHandler = (e) => {
    // prevent page scrolling when touching canvas
    if (e.type === "touchstart") e.preventDefault();
    handleMouseDown(e);
  };

  canvas.addEventListener("mousedown", downHandler,{ passive: false });
  canvas.addEventListener("touchstart", downHandler, { passive: false });

  return () => {
    canvas.removeEventListener("mousedown", downHandler,{ passive: false });
    canvas.removeEventListener("touchstart", downHandler,{ passive: false });
  };
}, [image, tool, eraserBox, showOriginal, color, fontSize, selectedEmoji, selectedSymbol]);

  

const handleMouseDown = (e) => {
  if (!image) return;

  const canvas = canvasRef.current;
  const ctx = canvas.getContext("2d");
  const rect = canvas.getBoundingClientRect();

  // Normalize coordinates for mouse/touch
  const getCoords = (event) => {
    const clientX = event.touches?.[0]?.clientX ?? event.clientX;
    const clientY = event.touches?.[0]?.clientY ?? event.clientY;
  
    const rect = canvasRef.current.getBoundingClientRect();
    const rawX = clientX - rect.left;
    const rawY = clientY - rect.top;
  
    return {
      x: (rawX - image.offsetX) / image.scaleX,
      y: (rawY - image.offsetY) / image.scaleY,
    };
  };
  

  const { clientX, clientY, x, y } = getCoords(e);

  if (showOriginal) return;

  // ---------------- Eraser ----------------
  if (tool === "eraser") {
    if (
      clientX - rect.left >= eraserBox.x &&
      clientX - rect.left <= eraserBox.x + eraserBox.size &&
      clientY - rect.top >= eraserBox.y &&
      clientY - rect.top <= eraserBox.y + eraserBox.size
    ) {
      setEraserBox((prev) => ({ ...prev, isDragging: true }));
  
      const eraserSize = eraserBox.size; // ✅ capture once
  
      const onMove = (moveEvent) => {
        moveEvent.preventDefault();
        const { rawX, rawY } = getEventCoordinates(moveEvent);
  
        const newX = rawX - eraserSize / 2;
        const newY = rawY - eraserSize / 2;
  
        setEraserBox((prev) => ({
          ...prev,
          x: newX,
          y: newY,
        }));
  
        // ✅ use eraserSize here (not prev)
        liveErase(rawX, rawY, eraserSize);
        drawCanvas();
      };
  
      const onUp = () => {
        setEraserBox((prev) => ({ ...prev, isDragging: false }));
        window.removeEventListener("mousemove", onMove);
        window.removeEventListener("mouseup", onUp);
        window.removeEventListener("touchmove", onMove);
        window.removeEventListener("touchend", onUp);
      };
  
      window.addEventListener("mousemove", onMove, { passive: false });
      window.addEventListener("mouseup", onUp);
      window.addEventListener("touchmove", onMove, { passive: false });
      window.addEventListener("touchend", onUp);
      return;
    }
  }
  
  

  // ---------------- Text Box ----------------
  if (tool === "text") {
    const clickedBox = textBoxes.find(
      (b) =>
        clientX - rect.left >= b.left &&
        clientX - rect.left <= b.left + b.width &&
        clientY - rect.top >= b.top &&
        clientY - rect.top <= b.top + b.height
    );

    if (clickedBox) {
      setSelectedBoxId(clickedBox.id);
      const offsetX = clientX - rect.left - clickedBox.left;
      const offsetY = clientY - rect.top - clickedBox.top;

      const onMove = (moveEvent) => {
        moveEvent.preventDefault();
        const { rawX: moveX, rawY: moveY } = getCoords(moveEvent);

        setTextBoxes((prev) =>
          prev.map((box) =>
            box.id === clickedBox.id
              ? { ...box, left: moveX - offsetX, top: moveY - offsetY }
              : box
          )
        );
        drawCanvas();
      };

      const onUp = () => {
        window.removeEventListener("mousemove", onMove);
        window.removeEventListener("mouseup", onUp);
        window.removeEventListener("touchmove", onMove);
        window.removeEventListener("touchend", onUp);
      };

      window.addEventListener("mousemove", onMove);
      window.addEventListener("mouseup", onUp);
      window.addEventListener("touchmove", onMove, { passive: false });
      window.addEventListener("touchend", onUp);
      return;
    }

    // Create new text box
    if (!textBoxes.some((b) => b.content === "")) {
      const newBox = {
        id: Date.now(),
        top: y * image.scaleY + image.offsetY,
        left: x * image.scaleX + image.offsetX,
        width: 200,
        height: 40,
        content: "",
        color,
        fontSize,
      };
      setTextBoxes((prev) => [...prev, newBox]);
      setSelectedBoxId(newBox.id);
      addActionToHistory({ type: "text", action: "add", box: newBox });
    }
    return;
  }

  // ---------------- Emoji ----------------
  if (tool === "emoji" && selectedEmoji) {
    drawnEmojis.current.push({ id: Date.now(), x, y, fontSize, emoji: selectedEmoji });
    addActionToHistory({ type: "emoji", action: "add", emoji: drawnEmojis.current.at(-1) });
    drawCanvas();
    return;
  }

  // ---------------- Symbol ----------------
  if (tool === "symbol" && selectedSymbol) {
    const newSym = { id: Date.now(), symbol: selectedSymbol, x, y, fontSize, color };
    drawnSymbols.current.push(newSym);
    addActionToHistory({ type: "symbol", action: "add", symbol: newSym });
    drawCanvas();
    return;
  }

  // ---------------- Pencil / Free Draw ----------------
  if (tool === "pencil" || tool === "highlight" || tool === "free-drawing") {
    let lastX = x;
    let lastY = y;
    let linesDrawn = [];
    let isDrawing = true;

    ctx.beginPath();
    ctx.moveTo(image.offsetX + x * image.scaleX, image.offsetY + y * image.scaleY);
    ctx.strokeStyle = tool === "highlight" ? color + "70" : color;
    ctx.lineWidth = tool === "highlight" ? 20 : 2;
    ctx.lineCap = "round";

    const handleMove = (moveEvent) => {
      moveEvent.preventDefault();
      if (!isDrawing) return;
      const { x: moveX, y: moveY } = getCoords(moveEvent);

      ctx.beginPath();
      ctx.moveTo(image.offsetX + lastX * image.scaleX, image.offsetY + lastY * image.scaleY);
      ctx.lineTo(image.offsetX + moveX * image.scaleX, image.offsetY + moveY * image.scaleY);
      ctx.stroke();

      linesDrawn.push({ start: { x: lastX, y: lastY }, end: { x: moveX, y: moveY }, color, tool });
      drawnLines.current.push(linesDrawn.at(-1));

      lastX = moveX;
      lastY = moveY;
    };

    const handleUp = () => {
      if (linesDrawn.length) addActionToHistory({ type: "free-draw", lines: [...linesDrawn] });
      isDrawing = false;

      window.removeEventListener("mousemove", handleMove);
      window.removeEventListener("mouseup", handleUp);
      window.removeEventListener("touchmove", handleMove);
      window.removeEventListener("touchend", handleUp);

      drawCanvas();
    };

    window.addEventListener("mousemove", handleMove);
    window.addEventListener("mouseup", handleUp);
    window.addEventListener("touchmove", handleMove, { passive: false });
    window.addEventListener("touchend", handleUp);

    e.preventDefault();
  }
};



  
  const handleEraserDown = (e) => {
    const { x, y } = getEventCoordinates(e);
    const rect = canvasRef.current.getBoundingClientRect();
  
    if (
      x - rect.left >= eraserBox.x &&
      x - rect.left <= eraserBox.x + eraserBox.size &&
      y - rect.top >= eraserBox.y &&
      y - rect.top <= eraserBox.y + eraserBox.size
    ) {
      setEraserBox((prev) => ({ ...prev, isDragging: true }));
  
      const onMove = (moveEvent) => {
        const { x: moveX, y: moveY } = getEventCoordinates(moveEvent);
        setEraserBox((prev) => ({
          ...prev,
          x: moveX - rect.left - prev.size / 2,
          y: moveY - rect.top - prev.size / 2,
        }));
      };
  
      const onUp = () => {
        setEraserBox((prev) => ({ ...prev, isDragging: false }));
        window.removeEventListener("mousemove", onMove);
        window.removeEventListener("mouseup", onUp);
        window.removeEventListener("touchmove", onMove);
        window.removeEventListener("touchend", onUp);
      };
  
      window.addEventListener("mousemove", onMove);
      window.addEventListener("mouseup", onUp);
      window.addEventListener("touchmove", onMove, { passive: false });
      window.addEventListener("touchend", onUp);
    }
  };
  const handleTextBoxDrag = (id, e) => {
    e.stopPropagation();
    e.preventDefault(); // prevent page scroll on touch
  
    const { x: startX, y: startY } = getEventCoordinates(e);
    const box = textBoxes.find((b) => b.id === id);
    const origLeft = box.left;
    const origTop = box.top;
  
    const onMove = (moveEvent) => {
      moveEvent.preventDefault(); // 🔑 stop scrolling on drag
      const { x: moveX, y: moveY } = getEventCoordinates(moveEvent);
      const dx = moveX - startX;
      const dy = moveY - startY;
  
      setTextBoxes((prev) =>
        prev.map((b) =>
          b.id === id ? { ...b, left: origLeft + dx, top: origTop + dy } : b
        )
      );
    };
  
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onUp);
    };
  
    window.addEventListener("mousemove", onMove, { passive: false });
    window.addEventListener("mouseup", onUp);
    window.addEventListener("touchmove", onMove, { passive: false });
    window.addEventListener("touchend", onUp);
  };
  
    
// Utility: always return both canvas and normalized coords
const getEventCoordinates = (e) => {
  if (!canvasRef.current || !image) return { x: 0, y: 0, rawX: 0, rawY: 0 };

  const canvas = canvasRef.current;
  const rect = canvas.getBoundingClientRect();

  let clientX, clientY;
  if (e.touches && e.touches.length > 0) {
    clientX = e.touches[0].clientX;
    clientY = e.touches[0].clientY;
  } else {
    clientX = e.clientX;
    clientY = e.clientY;
  }

  const rawX = clientX - rect.left;
  const rawY = clientY - rect.top;

  return {
    clientX,
    clientY,
    rawX,
    rawY,
    // normalized to image coordinates
    x: (rawX - image.offsetX) / image.scaleX,
    y: (rawY - image.offsetY) / image.scaleY,
  };
};

  
  
  
  const createTextBox = () => {
    if (!canvasRef.current || !image) return;
  
    const canvas = canvasRef.current;
    const defaultWidth = 200;
    const defaultHeight = 40;
  
    // Center on canvas
    const left = (canvas.width / (image?.scaleX || 1) - defaultWidth) / 2;
    const top = (canvas.height / (image?.scaleY || 1) - defaultHeight) / 2;
  
    const newBox = {
      id: Date.now(),
      pageIndex: activePage,
      top,
      left,
      width: defaultWidth,
      height: defaultHeight,
      content: "",
      color,
      fontSize,
    };
  
    setTextBoxes((prev) => [...prev, newBox]);
    setSelectedBoxId(newBox.id);
    setTool(null);
    addActionToHistory({ type: "text", action: "add", box: newBox });
  };
  
  
  
  
  const handleTextChange = (id, text) => {
    setTextBoxes((prev) =>
      prev.map((box) => (box.id === id ? { ...box, content: text } : box))
    );
  };
  const handleDragStart = (boxId, e) => {
    e.preventDefault();
    e.stopPropagation();
  
    const isTouch = e.type.startsWith("touch");
    const rect = canvasRef.current.getBoundingClientRect();
  
    const getClientX = ev => isTouch ? ev.touches[0].clientX : ev.clientX;
    const getClientY = ev => isTouch ? ev.touches[0].clientY : ev.clientY;
  
    const startX = getClientX(e) - rect.left;
    const startY = getClientY(e) - rect.top;
  
    const box = textBoxes.find(b => b.id === boxId);
    const scaleX = image?.scaleX || 1;
    const scaleY = image?.scaleY || 1;
  
    // offset relative to box's top-left
    const offsetX = startX - box.left * scaleX;
    const offsetY = startY - box.top * scaleY;
  
    const onMove = moveEvent => {
      moveEvent.preventDefault();
      const x = getClientX(moveEvent) - rect.left;
      const y = getClientY(moveEvent) - rect.top;
  
      setTextBoxes(prev =>
        prev.map(b =>
          b.id === boxId
            ? { ...b, left: (x - offsetX) / scaleX, top: (y - offsetY) / scaleY }
            : b
        )
      );
    };
  
    const onUp = () => {
      window.removeEventListener(isTouch ? "touchmove" : "mousemove", onMove);
      window.removeEventListener(isTouch ? "touchend" : "mouseup", onUp);
    };
  
    window.addEventListener(isTouch ? "touchmove" : "mousemove", onMove, { passive: false });
    window.addEventListener(isTouch ? "touchend" : "mouseup", onUp);
  };
  
  
  
  
  
  
  
  const handleSaveClick = () => {
    setShowConfirmation(true);
  };
  
  const handleResizeStart = (boxId, e) => {
    e.preventDefault();
    e.stopPropagation();
  
    const getClientCoords = event => {
      if (event.touches && event.touches[0]) {
        return { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }
      return { x: event.clientX, y: event.clientY };
    };
  
    const { x: startX, y: startY } = getClientCoords(e);
    const box = textBoxes.find(b => b.id === boxId);
    const startWidth = box.width;
    const startHeight = box.height;
    const scaleX = image?.scaleX || 1;
    const scaleY = image?.scaleY || 1;
  
    const onMove = moveEvent => {
      moveEvent.preventDefault();
      const { x: moveX, y: moveY } = getClientCoords(moveEvent);
      const dx = (moveX - startX) / scaleX; // reverse scaling
      const dy = (moveY - startY) / scaleY;
  
      setTextBoxes(prev =>
        prev.map(b =>
          b.id === boxId
            ? {
                ...b,
                width: Math.max(40, startWidth + dx),
                height: Math.max(20, startHeight + dy),
              }
            : b
        )
      );
    };
  
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onUp);
    };
  
    window.addEventListener("mousemove", onMove, { passive: false });
    window.addEventListener("mouseup", onUp);
    window.addEventListener("touchmove", onMove, { passive: false });
    window.addEventListener("touchend", onUp);
  };
  
  

  
  const saveImage = async () => {
    setShowConfirmation(false);
  
    try {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
  
      if (!canvas || !ctx || !image?.el) {
        console.error("Canvas or image not ready");
        return;
      }
  
      // Dynamically set canvas size based on image dimensions
      canvas.width = image.width;
      canvas.height = image.height;
  
      // Clear and fill white background
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
  
      // Draw the main image
      ctx.drawImage(image.el, 0, 0, canvas.width, canvas.height);
  
      // Draw lines (free drawing / pencil / highlight)
      drawnLines.current.forEach((line) => {
        const adjustedLine = {
          start: { x: line.start.x * image.scaleX, y: line.start.y * image.scaleY },
          end: { x: line.end.x * image.scaleX, y: line.end.y * image.scaleY },
          color: line.color,
          tool: line.tool,
        };
        drawLine(ctx, adjustedLine);
      });
  
      // Draw text boxes
      textBoxes.forEach((box) => {
        const x = box.left * image.scaleX;
        const y = box.top * image.scaleY;
  
        ctx.font = `${box.fontSize}px Arial`;
        ctx.fillStyle = box.color;
        ctx.textBaseline = "top";
  
        const lines = box.content.split("\n");
        lines.forEach((line, i) => {
          const lineY = y + i * (box.fontSize + 4);
          ctx.fillText(line, x, lineY);
        });
      });
  
      // Draw symbols
      for (const symbol of drawnSymbols.current || []) {
        const { symbol: symbolText, x, y, fontSize, color } = symbol;
        const scaledX = x * image.scaleX;
        const scaledY = y * image.scaleY;
  
        const symbolImageUrl = await createSymbolImage(symbolText, fontSize, color);
        const img = new Image();
        img.src = symbolImageUrl;
        await new Promise((resolve) => (img.onload = resolve));
  
        ctx.drawImage(img, scaledX, scaledY - fontSize / 2, fontSize, fontSize);
      }
  
      // Draw emojis
      for (const emoji of drawnEmojis.current || []) {
        const scaledX = emoji.x * image.scaleX;
        const scaledY = emoji.y * image.scaleY;
  
        ctx.font = `${emoji.fontSize || 24}px Arial`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(emoji.emoji, scaledX, scaledY);
      }
  
      // Convert canvas to blob
      const dataUrl = canvas.toDataURL("image/png");
      const blob = dataURLtoBlob(dataUrl);
  
      // Optional local download
      // saveAs(blob, "annotated.png");
  
      // Upload to server
      const formData = new FormData();
      const safeFileName = fileName || "annotated-image.png";
      formData.append("files", blob, safeFileName);
  
      const response = await fetch(
        `${ENVURL.PROCTUR_API_URL}/api/v2/onlineAssignment/annotate-file/save?file_id=${fileId}&inst_id=${instId}&student_id=${studentId}&attachment_id=${attachId}`,
        {
          method: "POST",
          headers: { Authorization: authToken },
          body: formData,
        }
      );
  
      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Server error ${response.status}: ${text}`);
      }
  
      toast.success("The annotated file has been saved successfully.");
    } catch (err) {
      console.error(err);
      toast.error("Failed to save image. Please try again.");
    }
  };
  
  
  
  
  
  
    const createSymbolImage = (symbol, fontSize, color) => {
        return new Promise((resolve) => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
         

          canvas.width = fontSize;
          canvas.height = fontSize;
          
          ctx.font = `${fontSize}px sans-serif`;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillStyle = color;
      
          ctx.fillText(symbol, canvas.width / 2, canvas.height / 2);
          
          const imageUrl = canvas.toDataURL();
          resolve(imageUrl);
        });
      };

  const downloadImage = async () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    ctx.drawImage(image, 0, 0);
    
    drawnLines.current.forEach((line) => drawLine(ctx, line));
    
    const canvasRect = canvas.getBoundingClientRect();
    
    textBoxes.forEach((box) => {
        const x = box.left - canvasRect.left;
        let y = box.top - canvasRect.top;
      
        ctx.font = `${box.fontSize}px Arial`; // Set font size and font family
        ctx.fillStyle = box.color;
        ctx.textBaseline = "top";
      
        const lines = box.content.split("\n");
        lines.forEach((line, i) => {
          const lineY = y + i * (box.fontSize + 4); // Adjust spacing
          ctx.fillText(line, x, lineY);
        });
      });
      for (const symbol of drawnSymbols.current || []) {
        const { symbol: symbolText, x, y, fontSize, color } = symbol;
    
        const symbolImageUrl = await createSymbolImage(symbolText, fontSize, color);
      
        const img = new Image();
        img.src = symbolImageUrl;
    
        await new Promise((resolve) => {
          img.onload = resolve;
        });
    
        ctx.drawImage(img, x, y - fontSize / 2, fontSize, fontSize);
      }
    
    
    
    const dataUrl = canvas.toDataURL("image/png");
    const blob = dataURLtoBlob(dataUrl);
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
      }
  
  
      const handleSymbolSelect = (symbol) => {
        setSelectedSymbol(symbol); // Update the selected symbol (e.g., tick, cross)
      };
      
  const dataURLtoBlob = (dataURL) => {
    const byteString = atob(dataURL.split(",")[1]);
    const mimeString = dataURL.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };
  const undo = () => {
    if (undoStack.length === 0) return;
    const lastAction = undoStack[undoStack.length - 1];
    setUndoStack((prev) => prev.slice(0, -1));
    setRedoStack((prev) => [...prev, lastAction]);
    if (lastAction.type === "reset") {
      const { drawnLines: prevLines, drawnSymbols: prevSymbols, drawnEmojis: prevEmojis, textBoxes: prevBoxes } = lastAction.data;
      drawnLines.current = prevLines;
      drawnSymbols.current = prevSymbols;
      drawnEmojis.current = prevEmojis;
      setTextBoxes(prevBoxes);
      drawCanvas();
    }
    
    if (lastAction.type === "text" && lastAction.action === "add") {
      setTextBoxes((prev) => prev.filter((box) => box.id !== lastAction.box.id));
    } 
    else if (lastAction.type === "draw") {
      if (lastAction.line) {
        drawnLines.current = drawnLines.current.filter(
          (line) => line !== lastAction.line
        );
      }
      drawCanvas();
    }
    else if (lastAction.type === "free-draw") {
      if (lastAction.lines) {
        drawnLines.current = drawnLines.current.slice(0, -lastAction.lines.length);
      }
      drawCanvas();
    }
    else if (lastAction.type === "emoji") {
      if (lastAction.action === "add") {
        drawnEmojis.current = drawnEmojis.current.filter(
          (e) => e.id !== lastAction.emoji.id
        );
      }
      drawCanvas();

    }
    else if (lastAction.type === "symbol") {
      if (lastAction.action === "add") {
        drawnSymbols.current = drawnSymbols.current.filter(
          (sym) => sym.id !== lastAction.symbol.id
        );
      }
      drawCanvas();
    }
    else if (lastAction.type === "erase") {
      if (lastAction.boxes) {
        setTextBoxes((prev) => [...prev, ...lastAction.boxes]);
      }
      drawCanvas();
    }
    
    
  };
  
  
  const redo = () => {
    if (redoStack.length === 0) return;
    const lastUndone = redoStack[redoStack.length - 1];
    setRedoStack((prev) => prev.slice(0, -1));
    setUndoStack((prev) => [...prev, lastUndone]);
  
    if (lastUndone.type === "text" && lastUndone.action === "add") {
      setTextBoxes((prev) => [...prev, lastUndone.box]);
    } else if (lastUndone.type === "draw") {
      drawnLines.current.push(lastUndone.line);
      drawCanvas();
    } else if (lastUndone.type === "free-draw") {
      drawnLines.current.push(...lastUndone.lines);
      drawCanvas();

    }
    else if (lastUndone.type === "reset") {
      drawnLines.current = [];
      drawnSymbols.current = [];
      drawnEmojis.current = [];
      setTextBoxes([]);
      drawCanvas();
    }
    
    else if (lastUndone.type === "emoji") {
      if (lastUndone.action === "add") {
        drawnEmojis.current.push(lastUndone.emoji);
        drawCanvas()

      } 
    }else if (lastUndone.type === "symbol") {
        if (lastUndone.action === "add") {
            drawnSymbols.current.push(lastUndone.symbol);
          drawCanvas();

        }
      }
      else if (lastUndone.type === "erase") {
        setTextBoxes((prev) =>
          prev.filter((box) =>
            !lastUndone.boxes.some((b) => b.id === box.id)
          )
        );
        drawCanvas();
      }
      
  };
  
  const addActionToHistory = (action) => {
    setUndoStack((prev) => [...prev, action]);
    setRedoStack([]); // Clear redo on new action
  };
  const [grabOffset, setGrabOffset] = useState({ x: 0, y: 0 });

  // 1. Helper for eraser size
const getEraserSize = () => {
  const baseSize = 40; // desktop default
  const scale = window.innerWidth / 720; // assume 720px base
  return Math.max(20, baseSize * scale); // keep at least 20px
};

// 2. Resize listener for mobile/desktop responsiveness
useEffect(() => {
  const handleResize = () => {
    setEraserBox((prev) => ({ ...prev, size: getEraserSize() }));
    drawCanvas();
  };
  window.addEventListener("resize", handleResize);
  handleResize(); // run once on mount
  return () => window.removeEventListener("resize", handleResize);
}, []);

// 3. Drag start logic (mouse/touch)
const handleEraserDragStart = (e, isTouch = false) => {
  e.preventDefault();

  const rect = canvasRef.current.getBoundingClientRect();
  const clientX = isTouch ? e.touches[0].clientX : e.clientX;
  const clientY = isTouch ? e.touches[0].clientY : e.clientY;

  // calculate initial grab offset
  const offsetX = clientX - rect.left - eraserBox.x;
  const offsetY = clientY - rect.top - eraserBox.y;

  setEraserBox((prev) => ({ ...prev, isDragging: true }));

  const moveEvent = isTouch ? "touchmove" : "mousemove";
  const endEvent = isTouch ? "touchend" : "mouseup";

  const onMove = (event) => {
    event.preventDefault();

    const moveX = isTouch ? event.touches[0].clientX : event.clientX;
    const moveY = isTouch ? event.touches[0].clientY : event.clientY;

    // new coordinates (relative to canvas)
    const x = moveX - rect.left - offsetX;
    const y = moveY - rect.top - offsetY;

    // update eraserBox position immediately
    setEraserBox((prev) => ({
      ...prev,
      x,
      y,
    }));

    // erase in real time with correct size
    liveErase(x, y, getEraserSize());
  };

  const onEnd = () => {
    setEraserBox((prev) => ({ ...prev, isDragging: false }));
    window.removeEventListener(moveEvent, onMove);
    window.removeEventListener(endEvent, onEnd);
  };

  window.addEventListener(moveEvent, onMove, { passive: false });
  window.addEventListener(endEvent, onEnd);
};

  
  const handleCanvasClick = (e) => {
    if (tool !== 'eraser') return;
    const rect = canvasRef.current.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const clickY = e.clientY - rect.top;
  
    setEraserBox((prev) => ({
      ...prev,
      x: clickX - prev.size / 2,
      y: clickY - prev.size / 2,
    }));
  };
  
  return (
    <>
      <div className="top-header">
        <span className="filename">{fileName}</span>
  
        {tools.save && (
          <button className="download-btn" title="Save Tool" onClick={handleSaveClick}>
            Save PDF
          </button>
        )}
      </div>
  
      {/* Original view toggle */}
      <div style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 9999,
        backgroundColor: 'white',
        padding: '8px 12px',
        borderRadius: '6px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
        fontSize: '14px'
      }}>
        <label>
          <input
            type="checkbox"
            checked={showOriginal}
            onChange={(e) => {
              const isChecked = e.target.checked;
              setShowOriginal(isChecked);
  
              if (isChecked) {
                // Backup current state
                backupState.current = {
                  lines: JSON.parse(JSON.stringify(drawnLines.current)),
                  symbols: JSON.parse(JSON.stringify(drawnSymbols.current)),
                  emojis: JSON.parse(JSON.stringify(drawnEmojis.current)),
                  texts: [...textBoxes],
                };
                // Clear annotations
                drawnLines.current = [];
                drawnSymbols.current = [];
                drawnEmojis.current = [];
                setTextBoxes([]);
                drawCanvas();
              } else {
                // Restore annotations
                if (backupState.current) {
                  drawnLines.current = JSON.parse(JSON.stringify(backupState.current.lines));
                  drawnSymbols.current = JSON.parse(JSON.stringify(backupState.current.symbols));
                  drawnEmojis.current = JSON.parse(JSON.stringify(backupState.current.emojis));
                  setTextBoxes([...backupState.current.texts]);
                  drawCanvas();
                }
              }
            }}
          />
          View Original
        </label>
      </div>
  
      {/* Save confirmation modal */}
      {showConfirmation && (
        <div className="modal-overlay">
          <div className="modal-content">
            <p className="modal-message">
              Annotations cannot be modified or deleted after saving. Do you want to proceed?
            </p>
            <div className="modal-buttons">
              <button className="cancel-button" onClick={() => setShowConfirmation(false)}>Cancel</button>
              <button className="save-button" onClick={saveImage}>Proceed To Save</button>
            </div>
          </div>
        </div>
      )}
  
      {/* Toolbar */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div className="toolbar fixed-toolbar">
          {tools.pencil && <button className={tool === "pencil" ? "active" : ""} title="Pencil Tool" onClick={() => setTool("pencil")}>✏️</button>}
          {tools.highlight && <button className={tool === "highlight" ? "active" : ""} title="Highlighter Tool" onClick={() => setTool("highlight")}>🟨</button>}
          {tools.freeDrawing && <button className={tool === "free-drawing" ? "active" : ""} title="Free-drawing Tool" onClick={() => setTool("free-drawing")}>🖊️</button>}
          {tools.text && <button className={tool === "text" ? "active" : ""} title="Text Tool" onClick={() => { setTool("text"); createTextBox(); }}>🔤</button>}
          {tools.undo && <button title="Undo Tool" onClick={undo}>↩️</button>}
          {tools.redo && <button title="Redo Tool" onClick={redo}>↪️</button>}
          {tools.reset && <button title="Reset Tool" onClick={handleReset}>♻️</button>}
  
          {/* Emoji dropdown */}
          {tools.emoji && (
            <div style={{ position: "relative" }}>
              <button
                className={tool === "emoji" ? "active" : ""}
                title="Emoji Tool"
                onClick={() => {
                  setTool("emoji");
                  setDropdownVisible(prev => !prev);
                }}
              >😀</button>
              {tool === "emoji" && isDropdownVisible && (
                <div style={{
                  position: "absolute",
                  bottom: "40px",
                  left: 0,
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "6px",
                  background: "#fff",
                  border: "1px solid #ccc",
                  padding: "8px",
                  borderRadius: "6px",
                  zIndex: 9999,
                }}>
                  {["😀","😎","😍","😊","🔥","👍","👌","👎","🎯","❤️","✅","⭐","💯","👏","✏️","📝"].map(e => (
                    <span key={e} onClick={() => { setSelectedEmoji(e); setDropdownVisible(false); }}
                          style={{ fontSize: "20px", cursor: "pointer", padding: 4, borderRadius: 4, userSelect: "none", textAlign: "center" }}>
                      {e}
                    </span>
                  ))}
                </div>
              )}
            </div>
          )}
  
          {/* Symbol selector */}
          {tools.symbol && (
            <select title="Symbol Tool" onChange={(e) => { const v = e.target.value; if(v) { handleSymbolSelect(v); setTool("symbol"); } e.target.selectedIndex = 0; }}>
              <option value="">𖤐</option>
              <option value="✓">✓ Tick</option>
              <option value="✕">✕ Cross</option>
              <option value="▢">▢ Square</option>
              <option value="○">○ Circle</option>
              <option value="☆">☆ Star</option>
              <option value="△">△ Triangle</option>
              <option value="→">→ Arrow</option>
              <option value="♡">♡ Heart</option>
            </select>
          )}
  
          {tools.eraser && <button className={tool === "eraser" ? "active" : ""} title="Eraser Tool" onClick={() => setTool("eraser")}>🧽</button>}
          {tools.color && <input type="color" title="Color Tool" value={color} onChange={e => setColor(e.target.value)} />}
          {tools.size && <input type="number" title="Size Tool" value={fontSize} onChange={e => setFontSize(Number(e.target.value))} />}
        </div>
  
        {/* Canvas wrapper */}
        <div className="canvas-wrapper" style={{
          position: "relative",
          width: "100vw",
          height: "100vh",
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          overflow: "auto",       // ✅ scrollbars visible
          touchAction: "none",    // ✅ disable touch-drag scrolling
          justifyContent: "center",
          backgroundColor: "#f0f0f0"
        }}>
          <canvas
            ref={canvasRef}
            onMouseDown={e => { handleMouseDown(e); handleCanvasClick(e); }}
            style={{
              position: "absolute",
              zIndex: 5,
              cursor: tool === "text" ? "default" : "crosshair",
              border: "1px solid #ccc",
              background: "#fff",
              touchAction: "none",  // ✅ prevent finger swipes from scrolling

            
            }}
          />
  
          {/* Text boxes */}
      {/* Text boxes */}
      {textBoxes.map(box => (
  <div
    key={box.id}
    className="text-box"
    style={{
      position: "absolute",
      left: (box.left || 0) * (image?.scaleX || 1),
      top: (box.top || 0) * (image?.scaleY || 1),
      width: Math.max((box.width|| 100) * (image?.scaleX || 1), 200),
      height: Math.max((box.height || 40) * (image?.scaleY || 1), 50),
      border: box.content === "" ? "1px dashed lightgrey" : "none",
      padding: 8,
      backgroundColor: "transparent",
      zIndex: 10,
      cursor: "move",
    }}
    // ✅ Only start drag if target is NOT textarea
    onMouseDown={e => { if (e.target.tagName !== "TEXTAREA") handleDragStart(box.id, e) }}
    onTouchStart={e => { if (e.target.tagName !== "TEXTAREA") handleDragStart(box.id, e) }}
  >
    <textarea
      id={`textarea-${box.id}`}
      style={{
        width: "100%",
        height: "100%",
        fontSize: Math.max((box.fontSize || 20) * (image?.scaleX || 1), 20),
        fontFamily: "Arial, sans-serif",
        color: box.color || "grey",
        background: "transparent",
        border: "none",
        resize: "none",
        outline: "none",
        cursor: "text",
      }}
      value={box.content}
      onChange={e => handleTextChange(box.id, e.target.value)}
      onFocus={() => setSelectedBoxId(box.id)}
      onBlur={() => setSelectedBoxId(null)}
      // ✅ prevent propagation so drag doesn’t block typing
      onMouseDown={e => e.stopPropagation()}
      onTouchStart={e => e.stopPropagation()}
    />
    <div
      className="resize-handle"
      onMouseDown={e => { e.stopPropagation(); handleResizeStart(box.id, e); }}
      onTouchStart={e => { e.stopPropagation(); handleResizeStart(box.id, e); }}
      style={{
        position: "absolute",
        right: 0,
        bottom: 0,
        width: 16,
        height: 16,
        background: "rgba(0,0,0,0.3)",
        cursor: "nwse-resize",
        opacity: selectedBoxId === box.id ? 1 : 0, // Change opacity based on selection

      }}
    />
  </div>
))}








  
          {/* Eraser */}
          {tool === "eraser" && !showOriginal && (
            <div
              ref={eraserRef}
              style={{
                position: "absolute",
                top: eraserBox.y,
                left: eraserBox.x,
                width: eraserBox.size,
                height: eraserBox.size,
                zIndex: 100,
                cursor: "grab",
                touchAction: "none", // ✅ important for mobile drag

              }}
              onMouseDown={(e) => handleEraserDragStart(e, false)}
              onTouchStart={(e) => handleEraserDragStart(e, true)}
              
            >
              <img src={eraserr} alt="Eraser" style={{ width: "100%", height: "100%" }} />
            </div>
          )}
        </div>
      </div>
    </>
  );
  }  
export default ImageAnnotator;